<template>  
  <div>
    <div v-if="viewType == 'Page'">
      <div id="comicnav-container-top" class="sign_1_1 bg-cover">
          <span ref="comicNavTopFirst" class="navbuttons navbar" @click="goToFirstPage()">First</span>
          <span ref="comicNavTopPrev" class="navbuttons navbar" @click="getPrevPage()">Previous</span>
          <span ref="comicNavTopNext" class="navbuttons navbar" @click="getNextPage()">Next</span>
          <span ref="comicNavTopLast" class="navbuttons navbar" @click="goToLastPage()">Last</span>
      </div>
      <div id="viewType" class="bg cover">
        <div>
          <label for="view-strip">Scroll</label>
          <input type="radio" id="view-strip" value="Strip" v-model="viewType"/>   
        </div>
        <div>
          <label for="view-page">Page</label>
          <input type="radio" id="view-page" value="Page" v-model="viewType"/>
        </div>
      </div>
      <div id="pageInfo" class="bg cover">
        <span id="chNo" v-html="chNo"></span>   
        <span id="pNo" v-html="pageNo"></span>
      </div>
      <div class="ComicReader bg-cover">
        <div id="page-container">
          <img v-show="imageLoading" class="page-img" src="~@/assets/placeholder.png"/>
          <b-img v-show="!imageLoading" :src="img_url" fluid alt="Page" class="page-img" @load="imageLoading = false" v-b-modal="'zoom_page'" @click="setZoomedImage"></b-img>
        </div>
        <b-modal id="zoom_page" body-class="zoomedModal" :hide-footer=true :hide-header=true>
          <div class="modalImgContainer">
            <img v-show="zoomedImageLoading" class="zoomImg" src="~@/assets/placeholder.png"/>
            <b-img v-show="!zoomedImageLoading" :src="zoomed_url" class="zoomImg" @load="zoomedImageLoading = false"/>
          </div>
        </b-modal>
      </div>
      <div id="comicnav-container-bot" class="sign_1_1 bg-cover">
          <span ref="comicNavBotFirst" class="navbuttons navbar" @click="goToFirstPage()">First</span>
          <span ref="comicNavBotPrev" class="navbuttons navbar" @click="getPrevPage()">Previous</span>
          <span ref="comicNavBotNext" class="navbuttons navbar" @click="getNextPage()">Next</span>
          <span ref="comicNavBotLast" class="navbuttons navbar" @click="goToLastPage()">Last</span>
      </div>
      <ExternalLinks></ExternalLinks>
      <CommentSection 
        v-bind:comments="comments"
        v-bind:chapterid="chapterid"
        v-bind:pageNum="pageNum"
      ></CommentSection>
    </div>
    <div v-if="viewType == 'Strip'">
      <div id="comicnav-container-bot" class="sign_1_1 bg-cover">
          <span ref="comicNavTopFirst" class="navbuttons navbar" @click="goToFirstChapter()">First</span>
          <span ref="comicNavTopPrev" class="navbuttons navbar" @click="getPrevChapter()">Previous</span>
          <span ref="comicNavTopNext" class="navbuttons navbar" @click="getNextChapter()">Next</span>
          <span ref="comicNavTopLast" class="navbuttons navbar" @click="goToLastChapter()">Last</span>
      </div>
      <div id="viewType" class="bg cover">
        <div>
          <label for="view-strip">Scroll</label>
          <input type="radio" id="view-strip" value="Strip" v-model="viewType"/>   
        </div>
        <div>
          <label for="view-page">Page</label>
          <input type="radio" id="view-page" value="Page" v-model="viewType"/>
        </div>
      </div>
      <div id="chapterInfo" class="bg-cover">
        <span id="chNo" v-html="chNo"></span>   
      </div>
      <div class="ComicReader bg-cover no-bg-img" v-for="(imageLink, i) in chapterPagesURLs" :key="i">
        <div>
          <img v-show="imageLoading" class="page-img" src="~@/assets/placeholder.png"/>
          <b-img v-show="!imageLoading" :src="imageLink" fluid alt="Page" class="page-img" @load="imageLoading = false"></b-img>
        </div>
      </div>
      <div id="comicnav-container-bot" class="sign_1_1 bg-cover">
          <span ref="comicNavBotFirst" class="navbuttons navbar" @click="goToFirstChapter()">First</span>
          <span ref="comicNavBotPrev" class="navbuttons navbar" @click="getPrevChapter()">Previous</span>
          <span ref="comicNavBotNext" class="navbuttons navbar" @click="getNextChapter()">Next</span>
          <span ref="comicNavBotLast" class="navbuttons navbar" @click="goToLastChapter()">Last</span>
      </div>
      <ExternalLinks></ExternalLinks>
      <SubscribeWidget/>
    </div> 
  </div>
</template>


<script>
import {db} from '@/firebase/init'
import ExternalLinks from '@/components/ExternalLinks'
import CommentSection from '@/components/CommentSection'
import SubscribeWidget from '@/components/SubscribeWidget'
export default {
  name: 'ComicReader',
  components: {
    ExternalLinks,
    CommentSection,
    SubscribeWidget
  },
  data(){
    return {
      chapterName: 'ChapterName',
      chapterNum: 0,
      latestChapter: 0,
      img_url: null,
      zoomed_url: null,
      imageLoading: false,
      zoomedImageLoading: false,
      Pimg_url:null,
      chapterid: null,
      chapterPagesURLs:[],
      viewType: 'Page',
      pageNum: 0,
      totalPages: 0,
      chapterBannerLabel: null,
      defaultBannerURL: 'https://firebasestorage.googleapis.com/v0/b/luny-comics.appspot.com/o/banners%2Fdefault.png?alt=media&token=76194546-38bd-48a7-8359-a81f8d74e23d',
      // comments: {
      //   name: null,
      //   comment: null,
      // },
      comments: [],
      numComments: 0,
      pageConfig: {
        //url: 'localhost:8080/#' + this.$route.fullPath,
        identifier: 'localhost:8080/#' + this.$route.fullPath
      } 
    }
  },
  watch: {
    viewType(newVal, oldVal) {
      if(newVal != 'Strip' && newVal != 'Page')
        this.viewType = oldVal
      else{
        if(newVal == 'Strip'){
          this.$router.push(`/${this.$route.params.chapterName}`)
          if(this.chapterNum == this.latestChapter){
            this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
            this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
            this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
            this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
          }
        }
        else{
          this.$router.push(`/${this.$route.params.chapterName}/${1}`)
          this.pageNum = 1
          this.queryImage(this.pageNum)
          this.$refs.comicNavTopLast.classList.value = "navbuttons navbar"
          this.$refs.comicNavTopNext.classList.value = "navbuttons navbar"
          this.$refs.comicNavBotLast.classList.value = "navbuttons navbar"
          this.$refs.comicNavBotNext.classList.value = "navbuttons navbar"
        }
      }
    }
  },
  methods: {
    /*this method gets the latest chapter so that when the user loads the webpage 
    the reader can display the latest page
    from the latest chapter*/
    getLatestChapterDoc(isStrip = false){
      db.collection("comics") // search in the comics collection  
      .orderBy('dateAdded', 'desc') //order by the dateAdded
      .limit(1)
      .get() //get
      .then(docs =>{
        //if doc is retrieved
        if(docs){
          docs.forEach((doc)=>{
          // console.log(doc.id);
          this.chapterid = doc.id;
          this.chapterName = 'Chapter' + doc.data().chapterNum
          this.chapterNum = doc.data().chapterNum
          this.latestChapter = this.chapterNum
          this.chapterBannerLabel = doc.data().bannerLabel
          // console.log(this.chapterid);
          })
        }else{
          throw "No Chapter Found"
        }
      }).then(()=>{
       this.getTotalPagesOfChapter(this.chapterid);
      }).then(()=>{
        if(!isStrip)
          this.getImageOfPagesOfChapter(this.chapterid);
        else
          this.getPagesOfChapter(this.chapterid);
        this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
      })
      .catch((err)=>{
          throw err;
      })
    }
    ,getSpecificChapterAndPageDoc(doc_id,pNum){
      var chapterNum = Number(doc_id.replace('chapter',''));
      db.collection("comics")
      .where("chapterNum","==",chapterNum)
      .limit(1)
      .get()
      .then(docs =>{
        if(docs){
          docs.forEach((doc) => {
            this.chapterid = doc.id;
            this.chapterName = this.getChapterName(doc.data().chapterNum)
            this.chapterNum = doc.data().chapterNum
            this.chapterBannerLabel = doc.data().bannerLabel
          })
        }
        else{
          throw "No Chapter Found"
        }
      }).then(()=>{
        this.getTotalPagesOfChapter(this.chapterid);
      }).then(()=>{
        this.getSpecificImageOfPagesOfChapter(this.chapterid, pNum);
      }).catch(err=>{
        throw err;
      })
    },
    getSpecificChapter(doc_id){
      var chapterNum = Number(doc_id.replace('chapter',''));
      db.collection("comics")
      .where("chapterNum","==",chapterNum)
      .limit(1)
      .get()
      .then(docs =>{
        if(docs){
          docs.forEach((doc) => {
            this.chapterid = doc.id;
            this.chapterName = this.getChapterName(doc.data().chapterNum)
            this.chapterNum = doc.data().chapterNum
            this.chapterBannerLabel = doc.data().bannerLabel
          })
        }
        else{
          throw "No Chapter Found"
        }
      }).then(()=>{
        this.getTotalPagesOfChapter(this.chapterid);
      }).then(()=>{
        this.getPagesOfChapter(this.chapterid);
      }).catch(err=>{
        throw err;
      }).then(() => {
        this.$router.push({name:"Comic-Strip",  params:{chapterName:('chapter'+this.chapterNum)}}).then(()=>{
             this.pageConfig.identifier = this.$route.fullPath;
          })
      })
    },
    getSpecificImageOfPagesOfChapter(doc_id, pNum){
      db.collection("comics")
      .doc(doc_id)
      .collection("pages")
      .orderBy("pageNum", "asc")
      .get()
      .then(docs=>{
        if(docs){
          docs.forEach((doc)=>{
            // console.log(doc.data().link);
            this.chapterPagesURLs.push(doc.data().link_resize);
            // console.log("added");
          })
        }
      }).then(()=>{
        this.queryImage(pNum);
        // console.log(pNum);
      })
    },
    getPagesOfChapter(doc_id){
      db.collection("comics")
      .doc(doc_id)
      .collection("pages")
      .orderBy("pageNum", "asc")
      .get()
      .then(docs=>{
        if(docs){
          docs.forEach((doc)=>{
            // console.log(doc.data().link);
            this.chapterPagesURLs.push(doc.data().link_resize);
            // console.log("added");
          })
        }
      })
    },
    //change
    getImageOfPagesOfChapter(doc_id){
      db.collection("comics")
      .doc(doc_id)
      .collection("pages")
      .orderBy("pageNum", "asc")
      .get()
      .then(docs=>{
        if(docs){
          docs.forEach((doc)=>{
            // console.log(doc.data().link);
            this.chapterPagesURLs.push(doc.data().link_resize);
            // console.log("added");
          })
        }
      }).then(()=>{
        this.queryImage(this.chapterPagesURLs.length)
      })
    },
    queryImage( pageNum){
        this.pageNum = pageNum;
        this.img_url = this.chapterPagesURLs[pageNum-1];
        // console.log('ROUTE:')
        // console.log(this.$route.fullPath)
          if((this.$route.params.pageNumber != this.pageNum && this.$route.params.chapterName != this.chapterid) ||
          (this.$route.params.pageNumber != this.pageNum && this.$route.params.chapterName == this.chapterid || 
          this.$route.params.chapterName != this.chapterid)){
          this.$router.push({name:"Comic-Page",  params:{chapterName:('chapter'+this.chapterNum), pageNumber: this.pageNum}}).then(()=>{
            // console.log("After pushing param: "+ this.$route.fullPath);
             //this.pageConfig.url = 'localhost:8080/#' + this.$route.fullPath;
             this.pageConfig.identifier = this.$route.fullPath;
              // console.log(this.pageConfig.identifier );
          })
        }
    },
    getImageURL(pageNum, action){
      
      // move to next page of current chapter
      if(action == "next" && pageNum < this.totalPages){
        pageNum +=1;
        this.queryImage(pageNum)
      }
      // move to prev page of current chapter
      else if(action == "prev" && pageNum > 1){
        pageNum-=1;
        this.queryImage(pageNum)
        var temp = this.chapterid.split("chapter");
        if(temp[1] == '1' && pageNum == 1){
          this.$refs.comicNavTopFirst.classList.value = "disabledButton navbar"
          this.$refs.comicNavTopPrev.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotFirst.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotPrev.classList.value = "disabledButton navbar"
        }
      }
      // move to first page of next chapter (if possible)
      else if(action == "next" && pageNum == this.totalPages){
        this.getNewChapter(this.chapterid, action)
      }
      
      // move to last page of previous chapter (if possible)
      else if(action == "prev" && pageNum == 1){
        this.getNewChapter(this.chapterid, action)
      }
    },
    getPrevPage(){
      if(this.$refs.comicNavTopPrev.classList.value != "disabledButton navbar" && this.$refs.comicNavBotPrev.classList.value != "disabledButton navbar"){
        this.imageLoading = true;
        this.getImageURL(this.pageNum, "prev")
        this.$refs.comicNavTopLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopNext.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotNext.classList.value = "navbuttons navbar"
      }
    },
    getNextPage(){
      if(this.$refs.comicNavTopNext.classList.value != "disabledButton navbar" && this.$refs.comicNavBotNext.classList.value != "disabledButton navbar"){
        this.imageLoading = true;
        this.getImageURL(this.pageNum, "next")
        this.$refs.comicNavTopFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopPrev.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotPrev.classList.value = "navbuttons navbar"
        if(this.chapterNum == this.latestChapter && this.pageNum == this.totalPages){
          this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
          this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
        }
      }
    },
    goToFirstPage(){
      if(this.$refs.comicNavTopFirst.classList.value != "disabledButton navbar" && this.$refs.comicNavBotFirst.classList.value != "disabledButton navbar"){
        this.resetData()
        this.imageLoading = true;
        this.chapterid = 'chapter1'
        this.goToNewChapter(this.chapterid, "first")
        this.$refs.comicNavTopLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopNext.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopFirst.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopPrev.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotNext.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotFirst.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotPrev.classList.value = "disabledButton navbar"
      }
    },
    goToNewChapter(chapterId, position, isStrip = false){
      db.collection("comics")
      .doc(chapterId)
      .get()
      .then((doc) => {
        var totalPages = doc.data().numPages
        // console.log("totalPages: " + totalPages)
        this.totalPages = totalPages
        this.chapterName = this.getChapterName(doc.data().chapterNum)
        this.chapterNum = doc.data().chapterNum
        this.chapterBannerLabel = doc.data().bannerLabel
        if(this.chapterNum == 1){
          this.$refs.comicNavTopFirst.classList.value = "disabledButton navbar"
          this.$refs.comicNavTopPrev.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotFirst.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotPrev.classList.value = "disabledButton navbar"
        }
        else if(this.chapterNum == this.latestChapter){
          this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
          this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
          this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
        }
      })
      .then(() => {
        // func getTotalPagesOfChapter
        db.collection("comics")
        .doc(chapterId)
        .collection("pages")
        .orderBy("pageNum", "asc")
        .get()
        .then(docs=>{
          if(docs){
            docs.forEach((doc)=>{
              // console.log(doc.data().link);
              this.chapterPagesURLs.push(doc.data().link_resize);
              // console.log("added");
            })
          }
        }).then(()=>{
          if(!isStrip){
            if(position == "first")
            this.queryImage(1)
            else{
              this.queryImage(this.totalPages)
            }
          }
          else{
            this.$router.push({name:"Comic-Strip",  params:{chapterName:('chapter'+this.chapterNum)}}).then(()=>{
             this.pageConfig.identifier = this.$route.fullPath;
            })
          }
        })
      })
    },
    getNewChapter(currentChapterId, action, isStrip = false){
      var chapters = []
      var newChapter
      db.collection('comics')
      .orderBy("dateAdded", "asc")
      .get()
      .then(docs =>{
        docs.forEach(doc => {
          //retrieve the id of the document
          var id = doc.id;
          chapters.push(id)
        });
      }).then(()=>{
        var arrPosition = chapters.indexOf(currentChapterId)
        // console.log("chapter position: " + arrPosition)
        if (action == "prev"){
          if(arrPosition == 0){
            newChapter = null
          }
          else{
            newChapter = chapters[arrPosition - 1]
          }
        }
        else if(action == "next"){
          if(arrPosition == chapters.length - 1){
            newChapter = null
          }
          else{
            newChapter = chapters[arrPosition + 1]
          }
        }
        if (newChapter != null){
          this.resetData()
          this.chapterid = newChapter
          if (action == "next"){
            this.goToNewChapter(this.chapterid, "first", isStrip)
          }
          else{
            this.goToNewChapter(this.chapterid, "last", isStrip)
          }
        }
      })
      .catch(err=>{
        throw err;
      })
    },
    goToLastPage(){
      if(this.$refs.comicNavTopLast.classList.value != "disabledButton navbar" && this.$refs.comicNavBotLast.classList.value != "disabledButton navbar" ){
        this.resetData()
        this.getLatestChapterDoc()
        this.imageLoading = true;
        this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopPrev.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotPrev.classList.value = "navbuttons navbar"
      }
    },
    goToFirstChapter(){
      if(this.$refs.comicNavTopFirst.classList.value != "disabledButton navbar" && this.$refs.comicNavBotFirst.classList.value != "disabledButton navbar"){
        this.resetData()
        this.imageLoading = true;
        this.chapterid = 'chapter1'
        this.goToNewChapter(this.chapterid, "first", true)
        this.$refs.comicNavTopLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopNext.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopFirst.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopPrev.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotNext.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotFirst.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotPrev.classList.value = "disabledButton navbar"
      }
    },
    getNextChapter(){
      if(this.$refs.comicNavTopNext.classList.value != "disabledButton navbar" && this.$refs.comicNavBotNext.classList.value != "disabledButton navbar"){
        this.imageLoading = true;
        this.getNewChapter(this.chapterid, "next", true)
        this.$refs.comicNavTopFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopPrev.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotPrev.classList.value = "navbuttons navbar"
      }
    },
    getPrevChapter(){
      if(this.$refs.comicNavTopPrev.classList.value != "disabledButton navbar" && this.$refs.comicNavBotPrev.classList.value != "disabledButton navbar"){
        this.imageLoading = true;
        this.getNewChapter(this.chapterid, "prev", true)
        this.$refs.comicNavTopLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopNext.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotLast.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotNext.classList.value = "navbuttons navbar"
      }
    },
    goToLastChapter(){
      if(this.$refs.comicNavTopLast.classList.value != "disabledButton navbar" && this.$refs.comicNavBotLast.classList.value != "disabledButton navbar" ){
        this.resetData()
        this.getLatestChapterDoc(true)
        this.imageLoading = true;
        this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
        this.$refs.comicNavTopFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavTopPrev.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
        this.$refs.comicNavBotFirst.classList.value = "navbuttons navbar"
        this.$refs.comicNavBotPrev.classList.value = "navbuttons navbar"
      }
    },
    resetData(){
      this.chapterName = ''
      this.chapterNum = -1
      this.img_url = null
      this.Pimg_url = null
      this.chapterid = null
      this.chapterPagesURLs = []
      this.pageNum = 0
      this.totalPages = 0
      this.chapterBannerLabel = null
      this.comments = []
      this.numComments = 0
    },
    getTotalPagesOfChapter(doc_id){
      db.collection("comics")
      .doc(doc_id)
      .get()
      .then((doc) => {
        var totalPages = doc.data().numPages
        // console.log("totalPages: " + totalPages)
        this.totalPages = totalPages
      })
    },
    
    getChapterName(chapterNum){
      var s = "Chapter " + chapterNum
      return s
    },
    setBannerType(value){
      this.$emit("bannerType", value);
    },
    // gets the banner url using the chapterBannerLabel
    queryBannerImage(chapterBannerLabel){
      // console.log("UPDATED CHAPTER BANNER URL: " + chapterBannerLabel);
      db.collection("banners")
      .doc(chapterBannerLabel)
      .get()
      .then((doc) => {
        if(doc){
          var bannerURL = doc.data().url
          this.setBannerType(bannerURL)
        }
        else{
          // default banner
          this.setBannerType(this.defaultBannerURL)
        }
      }).catch((err)=>{
        throw err;
      })
    },
    setZoomedImage(){
      var search = "resize_"
      this.zoomedImageLoading = true
      var n = this.img_url.indexOf(search)
      this.zoomed_url = this.img_url.slice(0,n) + this.img_url.slice(n+search.length);
    },
    keyHandler(e){
      if(this.viewType == 'Page'){
        if (e.code === 'ArrowRight')
          this.getNextPage()
        else if(e.code === 'ArrowLeft')
          this.getPrevPage()
      }
    },
  },
  computed: {
    // updates on chapter or pageNum change.
    pageNo() {
      return "Page" + " " + this.pageNum;
    },
    chNo(){
      // if chapter number has updated to latest value
      if(this.chapterNum != -1 && this.chapterBannerLabel != null){
        // console.log("CHAPTER BANNER URL: " + this.chapterBannerLabel);
        this.queryBannerImage(this.chapterBannerLabel)
      }
      return this.chapterName;
    }
  },
  //when the vue component is loaded these functions will be called
  created(){
    if(!this.$route.params.chapterName){
      this.getLatestChapterDoc()
      // console.log("route went latest");
    }
    else{
      //console.log(this.$route.params.chapterName)
      // get Latest chapter number
      db.collection("comics") // search in the comics collection  
      .orderBy('dateAdded', 'desc') //order by the dateAdded
      .limit(1)
      .get() //get
      .then(docs =>{
        //if doc is retrieved
        if(docs){
          docs.forEach((doc)=>{
            this.latestChapter = doc.data().chapterNum
          })
        }else{
          throw "No Chapter Found"
        }
      })
      .catch((err)=>{
          throw err;
      })
      if(this.$route.params.pageNumber){
        if(this.viewType != 'Page')
          this.viewType = 'Page'
        this.getSpecificChapterAndPageDoc( this.$route.params.chapterName, parseInt(this.$route.params.pageNumber))
      }
      else{
        if(this.viewType != 'Strip')
          this.viewType = 'Strip'
        this.getSpecificChapter(this.$route.params.chapterName)
      }
      //  console.log("route went specific");
      //  console.log(this.$route.params.pageNumber);
    }
    // this.setBannerType(this.bannerURL);
  },
  mounted(){
    if(!this.$route.params.chapterName){
      this.$refs.comicNavTopLast.classList.value = "disabledButton navbar"
      this.$refs.comicNavTopNext.classList.value = "disabledButton navbar"
      this.$refs.comicNavTopFirst.classList.value = "navbuttons navbar"
      this.$refs.comicNavTopPrev.classList.value = "navbuttons navbar"
      this.$refs.comicNavBotLast.classList.value = "disabledButton navbar"
      this.$refs.comicNavBotNext.classList.value = "disabledButton navbar"
      this.$refs.comicNavBotFirst.classList.value = "navbuttons navbar"
      this.$refs.comicNavBotPrev.classList.value = "navbuttons navbar"
    }
    window.addEventListener('keydown', this.keyHandler);
  },
  unmounted(){
    window.removeEventListener('keydown', this.keyHandler);
  }
}
</script>






<style>
/* reader styles */
.ComicReader {
  margin-right: auto;
  margin-left: auto;
  margin-top: 25px;
  display: flex;
	justify-content: center;
	align-items: center;
  background-image: url('../assets/paper_texture.png');
  background-repeat: no-repeat;
  min-width: 100%;
}
.no-bg-img {
  background-image: none;
}
#page-container{
	padding-left: 5%;
	padding-right: 5%;
  padding-top: 5%;
  padding-bottom: 5%;
}
.page-img{
  max-width: 100%;
  max-height: 100%;
}
#pageInfo{
    background-image: url('../assets/sign_1.png');
    background-repeat: round;
    display: flex;
    justify-content: space-between;
    align-content: center;
    text-align: center;
    margin-top: 15px;
    margin-left: 37%;
    margin-right: 37%;
    font-size: 2vw;
    padding: 1%;
    color: #FFFFFF;
}
#chapterInfo{
    background-image: url('../assets/sign_1.png');
    background-repeat: round;
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
    margin-top: 15px;
    margin-left: 37%;
    margin-right: 37%;
    font-size: 2vw;
    padding: 1%;
    color: #FFFFFF;
}
#viewType{
    background-image: url('../assets/sign_1.png');
    background-repeat: round;
    display: flex;
    justify-content: space-around;
    align-content: center;
    text-align: center;
    margin-top: 15px;
    margin-left: 37%;
    margin-right: 37%;
    font-size: 2vw;
    padding: 1%;
    color: #FFFFFF;
}
.label{
  padding-left: auto;
  padding-right: auto;
  text-align: center; 
}
#chNo{
    font-weight: bold;
}
#pNo{
    font-weight: bold;
}
/* comic navbar styles */
.sign_1_1 {
	background-image: url('../assets/sign_1.png');
    background-repeat: round;
}
#comicnav-container-top{
	margin-left: auto;
	margin-right: auto;
	margin-top: 25px;
  padding-left: 10%;
  padding-right: 10%;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
#comicnav-container-bot{
	margin-left: auto;
	margin-right: auto;
	margin-top: 25px;
  padding-left: 10%;
  padding-right: 10%;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

/* zoom modal styles */

.zoomImg{
  width: 100%;
  height: 100%;
}

.zoomedModal{
  padding: 5%;
  background: url('../assets/paper_texture.png')no-repeat center center; 
  background-size: 100% 100%;
  width: 100%;
  background-color: transparent !important;
}


#zoom_page___BV_modal_content_{
  background-color: transparent;
  border: none;
  max-width: 95vw;
  max-height: 95vh;
}

#zoom_page > .modal-dialog{
  max-width: 60vw;
}

/* comment section styles */
#commentsection-container{
	margin-left: auto;
	margin-right: auto;
	margin-top: 25px;
	background-color: #3A3347;
	padding: 3px;
  text-align: justify;
  color: #FFFFFF;
  border: 3px solid #733F53;
}
.comment{
	padding-left: 2%;
	border-left: 3px solid #733F53;
	padding-top: 10px;
}
.username{
    font-weight: bold;
}
.date{
    border-left: 2px solid #733F53;
}
.disabledButton{
  color: #888888;
  font-size: 3vw;
}

.loadingButton{
  text-shadow: 0 0 20px #2357e7, 0 0 30px #3b4b77;
}

.disabledButton:hover {
    cursor: pointer;
}

.flex-center {
  justify-content: center;
}
</style>